import React from 'react';

import RichText from '@/components/ui/RichText/RichText';

import type { RichTextProp } from '../../types';

interface DescriptionTestsListProps {
  subDescription?: RichTextProp | null;
  description?: RichTextProp | null;
  cardOpen: boolean;
}

export default function DescriptionTestsList({
  subDescription,
  description,
  cardOpen,
}: DescriptionTestsListProps): React.ReactElement {
  return (
    <>
      {subDescription?.content && (
        <div className={!cardOpen ? '[&_ul>li:nth-child(n+3)]:hidden' : ''}>
          <RichText
            styles={
              subDescription.styles ?? {
                ul: 'list-disc pl-5 mb-0 space-y-1',
                li: 'text-text-list text-base font-regular',
                p: 'text-text-list text-base font-regular',
              }
            }
          >
            {subDescription.content}
          </RichText>
        </div>
      )}
      {cardOpen && description?.content && (
        <RichText
          styles={
            description.styles ?? {
              ul: 'list-disc pl-5 space-y-1',
              li: 'text-text-list text-base font-regular ml-5',
              p: 'text-text-list text-base font-regular',
            }
          }
        >
          {description.content}
        </RichText>
      )}
    </>
  );
}
